"use client"

import { AppLogo } from "@/components/app-logo"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Footer } from "@/components/ui/footer"
import { useLanguage } from "@/lib/i18n/language-provider"
import { ArrowLeft, Github, Instagram, Linkedin } from "lucide-react"
import Link from "next/link"
import SmartLink from "@/components/smart-link";

export function BackButton() {
  return (
    <button
      onClick={() => {
        if (typeof window !== 'undefined' && window.location?.protocol === 'file:') {
          const pathname = window.location.pathname || '';
          const outIdx = pathname.lastIndexOf('/out/');
          const base = outIdx >= 0 ? pathname.substring(0, outIdx + '/out/'.length) : pathname;
          window.location.href = base + 'index.html';
        } else {
          if (window.history.length > 1) window.history.back();
          else window.location.href = '/';
        }
      }}
      aria-label="Retour"
      title="Retour"
      style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
    >
      ←
    </button>
  );
}

export default function AboutPage() {
  const { t } = useLanguage()

  return (
    <div className="min-h-screen bg-background text-foreground p-3 md:p-4 flex flex-col">
      <div className="max-w-4xl mx-auto w-full">
        {/* Header avec retour et titre */}
        <div className="border-b mb-4 md:mb-6">
          <div className="flex h-14 md:h-16 items-center px-2 md:px-4">
            <Button variant="ghost" size="icon" onClick={() => {
              if (typeof window !== 'undefined' && window.location?.protocol === 'file:') {
                const pathname = window.location.pathname || '';
                const outIdx = pathname.lastIndexOf('/out/');
                const base = outIdx >= 0 ? pathname.substring(0, outIdx + '/out/'.length) : pathname;
                window.location.href = base + 'index.html';
              } else {
                if (window.history.length > 1) window.history.back();
                else window.location.href = '/';
              }
            }} className="h-9 w-9 md:h-10 md:w-10">
              <ArrowLeft className="h-5 w-5 md:h-6 md:w-6" />
            </Button>
            <div className="ml-2 md:ml-4 flex items-center gap-2">
              <AppLogo />
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold tracking-tight">
                {t("about.title")}
              </h1>
            </div>
          </div>
        </div>

        <Card className="mb-6 md:mb-8">
          <CardContent className="space-y-3 md:space-y-4">
          <div className="pt-4 md:pt-6 border-t">
              <h2 className="text-lg md:text-xl font-semibold mb-2">{t("about.visualgrid.title")}</h2>
              <p className="text-sm md:text-base text-muted-foreground">
                {t("about.visualgrid.description")}
              </p>
            </div>

            <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t">
              <h2 className="text-lg md:text-xl font-semibold mb-2">{t("about.author.title")}</h2>
              <p className="text-sm md:text-base text-muted-foreground">
                {t("about.author.description")}
              </p>
            </div>
            <div className="mt-3 md:mt-4 flex flex-col sm:flex-row gap-2 sm:space-x-2">
                <Button variant="outline" size="sm" asChild className="w-full sm:w-auto">
                  <a href="https://www.instagram.com/axel.pouppart/" target="_blank" rel="noopener noreferrer">
                    <Instagram className="mr-2 h-4 w-4" />
                    {t("about.social.instagram")}
                  </a>
                </Button>
                <Button variant="outline" size="sm" asChild className="w-full sm:w-auto">
                  <a href="https://www.linkedin.com/in/axel-pouppart-427546206/" target="_blank" rel="noopener noreferrer">
                    <Linkedin className="mr-2 h-4 w-4" />
                    {t("about.social.linkedin")}
                  </a>
                </Button>
              </div>
          </CardContent>
        </Card>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mb-6 md:mb-8">
          <Button onClick={() => {
            if (typeof window !== 'undefined' && window.location?.protocol === 'file:') {
              const pathname = window.location.pathname || '';
              const outIdx = pathname.lastIndexOf('/out/');
              const base = outIdx >= 0 ? pathname.substring(0, outIdx + '/out/'.length) : pathname;
              window.location.href = base + 'index.html';
            } else {
              if (window.history.length > 1) window.history.back();
              else window.location.href = '/';
            }
          }} className="w-full sm:w-auto">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t("nav.back")}
          </Button>
          <Button variant="outline" asChild className="w-full sm:w-auto">
            <SmartLink href="/changelogs/">
              {t("nav.changelogs")}
            </SmartLink>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  )
} 